import React, { useEffect, useState } from 'react'
import styles from './LeadQualityScreen.module.css'
import LeadQualityHeroComponent from './LeadQualityHeroComponent'
import LeadCallingSummaryComponent from './LeadCallingSummaryComponent'
import LeadPerformanceSummaryComponent from './LeadPerformanceSummaryComponent'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { connect, useDispatch } from "react-redux";
import {
 setCurrentRoute
} from '../../Redux/actions'
import { useLocation } from "react-router-dom";

interface LeadQualityScreenProps {
    lqcScoreDescriptions: any
}

const LeadQualityScreen: React.FC<LeadQualityScreenProps> = ({lqcScoreDescriptions}) => {
     const [cRoute,setCRoute]=useState("") 
     
    const dispatcher = useDispatch();
          
               const location = useLocation();
                
                  useEffect(() => {
                    dispatcher(setCurrentRoute(location.pathname))
                    setCRoute(location.pathname)
                  }, [location]);

    return (
        <div id="leadQualityDashboard" className={styles.LqsWrapper}>
            <LeadQualityHeroComponent leadCallingScoreType={""} />
            {/* {performance &&
                <div className={`${styles.LqsAlert} ${styles[performance]}`}>
                    {(performance == "good") &&
                        <>
                            <span className={`${styles.LqscsBannerIcon} ${styles[performance]}`}>
                                <ThumbUpIcon className={styles.ThumbUpIcon} />
                            </span>
                            You are among the <span className={styles.TextHightlight}> Top</span> performing agents in Bangalore.
                        </>
                    }
                    {(performance == "moderate") &&
                        <>
                            <span className={`${styles.LqscsBannerIcon} ${styles[performance]}`}>
                                <InfoOutlinedIcon className={styles.infoIcon} />
                            </span>
                            You are among the <span className={styles.TextHightlight}> Average performing</span> agents in bangalore
                        </>
                    }
                    {(performance == "poor") &&
                        <>
                            <span className={`${styles.LqscsBannerIcon} ${styles[performance]}`}>
                                <InfoOutlinedIcon className={styles.infoIcon} />
                            </span>
                            You are among the<span className={styles.TextHightlight}> Poor performing</span> agents in bangalore
                        </>
                    }
                </div>
            } */}
            <LeadCallingSummaryComponent leadCallingScoreType={lqcScoreDescriptions.overallLeadCalling} />
            <LeadPerformanceSummaryComponent leadPerformanceScoreType={lqcScoreDescriptions.overallLeadQualification} />
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
        lqcScoreDescriptions: state.lqcReportData.lqcScoreDescriptions
    };
};

export default connect(mapStateToProps)(LeadQualityScreen);